import { XMLParser } from 'fast-xml-parser';

export interface StudyAnalysisObservation {
  code: string;
  value: number;
  unit?: string;
}

const SKIP_TAGS = new Set([
  'StudyStatus',
  'Warnings',
  'BraceletMessage',
  'SnoreBPChart_Y_axis',
  'SnoreDb_Y_axis',
  'StagesChart_Y_axis',
]);

const parser = new XMLParser({ ignoreAttributes: false, attributeNamePrefix: '@_' });

export function parseCloudPATStudyXmlAnalysis(xmlString: string): StudyAnalysisObservation[] {
  const doc = parser.parse(xmlString) as { study?: { analysis?: Record<string, unknown> } };
  const analysis = doc?.study?.analysis;
  if (!analysis) {
    return [];
  }

  const results: StudyAnalysisObservation[] = [];

  for (const [tag, raw] of Object.entries(analysis)) {
    if (SKIP_TAGS.has(tag) || tag.startsWith('@_')) {
      continue;
    }

    let numericValue: number;
    let unit: string | undefined;

    if (typeof raw === 'object' && raw !== null) {
      const entry = raw as Record<string, unknown>;
      const content = entry['#text'];
      if (content === undefined || content === 'N/A' || content === 'NotDetected') {
        continue;
      }
      numericValue = Number(content);
      unit = typeof entry['@_units'] === 'string' ? entry['@_units'] : undefined;
    } else {
      if (raw === undefined || raw === null || raw === 'N/A' || raw === 'NotDetected') {
        continue;
      }
      numericValue = Number(raw);
    }

    if (Number.isNaN(numericValue)) {
      continue;
    }

    results.push({ code: tag, value: numericValue, unit });
  }

  return results;
}
